import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { culturesSaga } from './saga';
import {
  CulturesState,
  ICulture,
  ISortedListCulture,
  ICreateOrEditCulturePayload,
  IGetCultureDetailsPayload,
  ISetCultureDetailsPayload,
} from './types';

export const initialState: CulturesState = {
  cultures: [],
  loading: false,
  culturesList: {
    loading: false,
    cultures: {
      cultures: [],
      companies: [],
    },
  },
  cultureDetails: {
    loading: false,
    culturesArr: [],
    companyId: null,
  },
  createCulture: {
    loading: false,
  },
};

const slice = createSlice({
  name: 'cultures',
  initialState,
  reducers: {
    getCultures(state) {
      state.loading = true;
    },
    setCultures(state, action: PayloadAction<ICulture[]>) {
      state.cultures = action.payload;
    },
    setCulturesLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    getCulturesList(
      state,
      action: PayloadAction<{
        hiikoEnvironmentId: number;
        cultureId: number | null;
        seasonId: number;
      }>,
    ) {
      state.culturesList.loading = true;
    },
    setCulturesList(state, action: PayloadAction<ISortedListCulture>) {
      state.culturesList.cultures = action.payload;
    },
    setCulturesListLoading(state, action: PayloadAction<boolean>) {
      state.culturesList.loading = action.payload;
    },
    getCultureDetails(state, action: PayloadAction<IGetCultureDetailsPayload>) {
      state.cultureDetails.loading = true;
      state.cultureDetails.culturesArr = [];
      state.cultureDetails.companyId = null;
    },

    setCultureDetails(state, action: PayloadAction<ISetCultureDetailsPayload>) {
      state.cultureDetails.culturesArr = action.payload.culturesArr;
      state.cultureDetails.companyId = action.payload.companyId;
    },

    setCultureDetailsLoading(state, action: PayloadAction<boolean>) {
      state.cultureDetails.loading = action.payload;
    },
    createOrEditCulture(
      state,
      action: PayloadAction<ICreateOrEditCulturePayload>,
    ) {
      state.createCulture.loading = true;
    },
    setCreateOrEditCultureLoading(state, action: PayloadAction<boolean>) {
      state.createCulture.loading = action.payload;
    },
  },
});

export const { actions: culturesActions } = slice;

export const useCulturesSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: culturesSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useCulturesSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
